import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { View, TouchableOpacity, Text, ViewPropTypes, Linking } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { Icon, Txt } from '../../../components'
import { useTopbarStyles as useStyles } from './styles'

import * as myOffersActions from '../../../redux/offers/myOffersActions'
import { initialState } from '../../../redux/offers/myOffersReducer'

import { useTheme } from '../../../theming/ThemeProvider'
import { initSelector } from '../../../redux/initReducer/initSelector'
import UserPhoto from './UserPhoto'
import { usePlatforms } from '../../../hooks/usePlatforms'
import ImageComponent from '../../../components/Image'
import { useIsDemo } from '../../../hooks/useIsDemo'

const Topbar = ({ title, style, display }) => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const isDemo = useIsDemo()
  const styles = useStyles(theme, isDesktop, isDemo)
  const { hotOffers } = useSelector(initSelector)
  const { theme: themeName } = useSelector(state => state.globalThemeReducer)
  const onOpenDrawer = () => navigation.openDrawer()

  const openHotOffers = useCallback(() => {
    dispatch(myOffersActions.setFilters({ ...initialState.filters, filterBy: 'hot' }))
    navigation.navigate(
      'offers', { screen: 'myOffers' }
    )
  }, [dispatch, navigation])

  const handleRequestFullAccess = () => Linking.openURL('https://edgecapacitydemo.typeform.com/to/Mgyo2E')
  return (
    <View style={[style, styles.header]}>
      <View style={[{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }, isDemo && { alignSelf: 'flex-start', marginTop: 10 }]}>
        {display && (
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={onOpenDrawer}
            style={styles.title}
            testID='topbarDrawerButton'
            accessibilityLabel='topbarDrawerButton'
          >
            <Icon
              name='Bars'
              height={20}
              width={20}
              fill={theme.BUNKER}
            />
            <Text style={{ fontSize: 23, fontWeight: 'bold', marginLeft: 10, color: theme.BUNKER }}>
              {title}
            </Text>
          </TouchableOpacity>
        )}
      </View>
      <View style={styles.rightItems}>
        {isTablet ? (
          <View style={styles.detailsLarge}>
            <View style={[styles.buttonsContainer]}>
              {isDemo ? (
                <TouchableOpacity
                  activeOpacity={0.8}
                  style={styles.requestAccessLarge}
                  onPress={handleRequestFullAccess}
                  testID='topbarFullAccessButton'
                >
                  <Txt
                    color='WHITE'
                    text='Request Full Access'
                    identity='body2'
                    style={{ fontWeight: '600' }}
                  />
                </TouchableOpacity>
              ) : <></>}
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.hotOfferLarge}
                onPress={openHotOffers}
                testID='topbarHotOfferButton'
              >
                <Icon
                  name='HotOffer2'
                  width={16}
                  height={16}
                  fill={theme.WHITE_TEXT}
                  style={{ marginRight: 10 }}
                />
                <Txt
                  color='WHITE_TEXT'
                  text='New Hot Offers'
                  identity='body2'
                  style={{ fontWeight: '600' }}
                />
                {Boolean(hotOffers) && (
                  <View style={styles.hotOfferDotLarge}>
                    <Txt
                      color='WHITE_TEXT'
                      text={hotOffers}
                      identity='body3Bold'
                    />
                  </View>
                )}
              </TouchableOpacity>
            </View>

            <View style={styles.logo}>
              <ImageComponent name={themeName === 'LIGHT_THEME' ? 'logoDark' : 'logoLight'} />
            </View>
          </View>
        ) : (
          <View>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.hotOffer}
                onPress={openHotOffers}
                testID='topbarHotOfferButton'
                accessibilityLabel='topbarHotOfferButton'
              >
                <Icon
                  name='HotOffer'
                  width={25}
                  height={25}
                  fill={theme.BUNKER}
                />
                {Boolean(hotOffers) && <View style={styles.hotOfferDot} />}
              </TouchableOpacity>
              <UserPhoto />
            </View>

            {isDemo ? (
              <TouchableOpacity
                activeOpacity={0.8}
                style={[styles.requestAccessLarge, { marginTop: 10 }]}
                onPress={handleRequestFullAccess}
                testID='topbarFullAccessButton'
              >
                <Txt
                  color='WHITE'
                  text='Request Full Access'
                  identity='body2'
                  style={{ fontWeight: '600' }}
                />
              </TouchableOpacity>
            ) : <></>}
          </View>
        )}
      </View>
    </View>
  )
}

Topbar.propTypes = {
  display: PropTypes.bool,
  title: PropTypes.string.isRequired,
  style: ViewPropTypes.style
}

export default Topbar
